import { GlobalImages } from '../../images';
import { PayType } from '../../utils';
import { appI18n } from '../../i18n';

export const PayItems = {
  [PayType.sberPayRu]: {
    title: 'SberPay',
    img: GlobalImages.paySber,
  },
  [PayType.cardRu]: {
    title: 'Visa/Mastercard/Mir',
    img: GlobalImages.payCard,
  },
  [PayType.sbpRu]: {
    title: 'SBP',
    img: GlobalImages.paySbp,
  },
  [PayType.stripe]: {
    title: 'Stripe',
    img: GlobalImages.payStripe,
  },
  [PayType.yoomoneyRu]: {
    title: 'Yoomoney',
    img: GlobalImages.payYoomoney,
  },
  [PayType.alipay]: {
    get title() {
      return appI18n.t('pkg_common.pay.alipay');
    },
    img: GlobalImages.aliPay,
  },
  [PayType.wxpay]: {
    get title() {
      return appI18n.t('pkg_common.pay.wechat_pay');
    },
    img: GlobalImages.weChatPay,
  },
  [PayType.offline]: {
    get title() {
      return appI18n.t('pkg_common.pay.offline_pay');
    },
    img: '',
  },
};
